export default "__VITE_ASSET__CD7pF5dN__"